import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createTelemetryFailed, createTelemetrySuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* createTelemetry(action) {
  try {
    const url = `${BACKEND_URL}/telemetry`;
    const pool = action.payload;
    const response = yield makeRequest(url, pool, action, 'POST', true);
    if (response.status === CREATED) {
      const data = yield getBodyJson(response);
      yield put(createTelemetrySuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      const data = yield getBodyJson(response);
      yield put(createTelemetryFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createTelemetryFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
